/**
 * レコードダウンロードリクエスト作成ページ専用i18n定数
 */

export const CREATE_RECORDS_DOWNLOAD_REQUEST_I18N = {
  // 性別オプション
  sex: {
    male: $localize`:@@admin.createRecordsDownloadRequest.sex.male:男性`,
    female: $localize`:@@admin.createRecordsDownloadRequest.sex.female:女性`,
    other: $localize`:@@admin.createRecordsDownloadRequest.sex.other:その他`,
  },

  // ステータス
  status: {
    active: $localize`:@@admin.createRecordsDownloadRequest.status.active:有効`,
    inactive: $localize`:@@admin.createRecordsDownloadRequest.status.inactive:無効`,
  },

  // アカウントグループ
  accountGroup: {
    staff: $localize`:@@admin.createRecordsDownloadRequest.accountGroup.staff:スタッフ`,
    user: $localize`:@@admin.createRecordsDownloadRequest.accountGroup.user:ユーザー`,
  },

  // ユーザー名
  userName: {
    anonymous: $localize`:@@admin.createRecordsDownloadRequest.userName.anonymous:匿名計測者`,
  },

  // ナビゲーション
  nav: {
    backToList: $localize`:@@admin.createRecordsDownloadRequest.nav.backToList:レコードダウンロード`,
  },

  // ボタン
  button: {
    close: $localize`:@@admin.createRecordsDownloadRequest.button.close:閉じる`,
  },

  // メッセージ
  message: {
    downloadRequestCreated: $localize`:@@admin.createRecordsDownloadRequest.message.downloadRequestCreated:ダウンロードリクエストが作成されました。\nダウンロード用データの準備には数分から数十分かかることがあります。\nファイルの準備ができたら登録されたメールアドレスにお知らせメールが届きます。`,
  },
} as const;

export type CreateRecordsDownloadRequestI18n = typeof CREATE_RECORDS_DOWNLOAD_REQUEST_I18N;
